export default __webpack_public_path__ + "static/media/full2.1f45e549.jpg";